/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Koreastudies17Inputs */

const en__field_enum_study_koreastudies17 = /** @type {(inputs: _Field_Enum_Study_Koreastudies17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korea Studies`)
};

const de__field_enum_study_koreastudies17 = /** @type {(inputs: _Field_Enum_Study_Koreastudies17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koreastudien`)
};

/**
* | output |
* | --- |
* | "Korea Studies" |
*
* @param {_Field_Enum_Study_Koreastudies17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_koreastudies17 = /** @type {((inputs?: _Field_Enum_Study_Koreastudies17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Koreastudies17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_koreastudies17(inputs)
	return de__field_enum_study_koreastudies17(inputs)
});
export { _field_enum_study_koreastudies17 as "_field_enum_STUDY_KOREASTUDIES" }